import { ServiceFetch } from '../service-fetch'

export default class CustomerTierTypeModel extends ServiceFetch {
    generateCustomerTierTypeLastCode = (data) => this.authFetch({
        url: 'customer-tier-type/generateCustomerTierTypeLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerTierTypeBy = (data) => this.authFetch({
        url: 'customer-tier-type/getCustomerTierTypeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerTierTypeByCode = (data) => this.authFetch({
        url: 'customer-tier-type/getCustomerTierTypeByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerTierTypeBy = (data) => this.authFetch({
        url: 'customer-tier-type/updateCustomerTierTypeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertCustomerTierType = (data) => this.authFetch({
        url: 'customer-tier-type/insertCustomerTierType',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deleteCustomerTierTypeByCode = (data) => this.authFetch({
        url: 'customer-tier-type/deleteCustomerTierTypeByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}